import React, { useEffect } from 'react';
import { Row, Col, Container, Form, Button, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';

import logo from '../../../assets/images/logo-white.png';
import login1 from '../../../assets/images/login/1.png';
import login2 from '../../../assets/images/login/2.png';
import login3 from '../../../assets/images/login/3.png';
import { useDispatch, useSelector } from 'react-redux';
import { CreateAuths, ErrorClear } from '../../../store/Auth/Slice';
import { handleToast } from '../../../toast';

SwiperCore.use([Navigation, Autoplay]);

const SignUp = () => {
  const navigate = useNavigate();
const dispatch = useDispatch();
const {error,loading} = useSelector((state) => state.auth);

  const initialValues = {
    fullName: '',
    email: '',
    password: '',
    terms: false,
    dob: '',
    gender: '',
    contact_number: '',
    role:''
  };

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required('Full Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().required('Password is required').min(6, 'Password must be at least 6 characters'),
 
    dob: Yup.date().required('Date of Birth is required').nullable(),
    gender: Yup.string().required('Gender is required'),
    contact_number: Yup.string()
      .matches(/^[0-9]+$/, 'Contact number must be only digits')
      .min(10, 'Contact number must be at least 10 digits')
      .required('Contact number is required'),
  });

  const handleSubmit =async (values) => {
 
   
   const res =await dispatch(CreateAuths(values))
   console.log(res,'res');
  };


  useEffect(() => {
   if (error) {
     const errorMessage = error.message ? error.message[0] : error.error;
       dispatch(handleToast(errorMessage || 'An error occurred', 'error'));
       
       dispatch(ErrorClear())
   }
 }, [error, dispatch]);
  return (
    <section className="sign-in-page">
      <div id="container-inside">
        <div id="circle-small"></div>
        <div id="circle-medium"></div>
        <div id="circle-large"></div>
        <div id="circle-xlarge"></div>
        <div id="circle-xxlarge"></div>
      </div>
      <Container className="p-0">
        <Row className="no-gutters">
          <Col md="6" className="text-center pt-5">
            <div className="sign-in-detail text-white">
              <Link className="sign-in-logo mb-5" to="#"><Image src={logo} className="img-fluid" alt="logo" /></Link>
              <div className="sign-slider overflow-hidden">
                <Swiper 
                  spaceBetween={30} 
                  centeredSlides={true} 
                  autoplay={{ delay: 2000, disableOnInteraction: false }} 
                  className="list-inline m-0 p-0 ">
                  <SwiperSlide>
                    <Image src={login1} className="img-fluid mb-4" alt="logo" />
                    <h4 className="mb-1 text-white">Find new friends</h4>
                    <p>It is a long established fact that a reader will be distracted by the readable content.</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={login2} className="img-fluid mb-4" alt="logo" />
                    <h4 className="mb-1 text-white">Connect with the world</h4>
                    <p>It is a long established fact that a reader will be distracted by the readable content.</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={login3} className="img-fluid mb-4" alt="logo" />
                    <h4 className="mb-1 text-white">Create new events</h4>
                    <p>It is a long established fact that a reader will be distracted by the readable content.</p>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </Col>
          <Col md="6" className="bg-white pt-5 pt-5 pb-lg-0 pb-5">
            <div className="sign-in-from">
              <h1 className="mb-0">Sign Up</h1>
              <p>Enter your email address and password to access admin panel.</p>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <Form onSubmit={handleSubmit} className="mt-4">
                    <Form.Group className="form-group">
                      <Form.Label>Your Full Name</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="fullName"
                        value={values.fullName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.fullName && !!errors.fullName}
                        placeholder="Your Full Name"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.fullName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control 
                        type="email" 
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && !!errors.email}
                        placeholder="Enter email"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Password</Form.Label>
                      <Form.Control 
                        type="password" 
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.password && !!errors.password}
                        placeholder="Password"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className='row'>
                    <Form.Group className="form-group col-6">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control 
                        type="date" 
                        name="dob"
                        value={values.dob}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.dob && !!errors.dob}
                        placeholder="Date of Birth"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.dob}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="form-group col-6">
                      <Form.Label>Gender</Form.Label>
                      <Form.Control 
                        as="select"
                        name="gender"
                        value={values.gender}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.gender && !!errors.gender}
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.gender}
                      </Form.Control.Feedback>
                    </Form.Group>

                    </div>
                    <Form.Group className="form-group">
                      <Form.Label>Contact Number</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="contact_number"
                        value={values.contact_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.contact_number && !!errors.contact_number}
                        placeholder="Contact Number"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.contact_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className="d-inline-block w-100">
                      <Form.Check className="d-inline-block mt-2 pt-1">
                        <Form.Check.Input 
                          type="checkbox"
                          name="terms"
                          value={values.terms}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.terms && !!errors.terms}
                          className="me-2" 
                          id="customCheck1"
                        />
                        <Form.Check.Label>
                          I accept <Link to="#">Terms and Conditions</Link>
                        </Form.Check.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.terms}
                        </Form.Control.Feedback>
                      </Form.Check>
                      <Button type="submit" className="btn-primary float-end">Sign Up</Button>
                    </div>
                    <div className="sign-info">
                      <span className="dark-color d-inline-block line-height-2">
                        Already Have Account? <Link to="/auth/sign-in">Log In</Link>
                      </span>
                      <ul className="iq-social-media">
                        <li>
                          <Link to="#">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 16 16" fill="currentColor">
                              <title>facebook</title>
                              <path d="M15 16h-14c-0.553 0-1-0.447-1-1v-14c0-0.553 0.447-1 1-1h14c0.553 0 1 0.447 1 1v14c0 0.553-0.447 1-1 1zM5.804 13.293v-5.277h-1.766v-2.053h1.766v-1.515c0-1.747 1.045-2.71 2.663-2.71 0.771 0 1.571 0.137 1.571 0.137v1.726h-0.885c-0.872 0-1.144 0.541-1.144 1.099v1.263h2.014l-0.319 2.053h-1.695v5.277h-2.205z"></path>
                            </svg>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 28 28" fill="currentColor">
                              <title>twitter</title>
                              <path d="M23.954 4.569c-0.885 0.389-1.83 0.654-2.825 0.775 1.014-0.611 1.794-1.574 2.163-2.723-0.951 0.555-2.005 0.959-3.127 1.184-0.897-0.957-2.178-1.555-3.594-1.555-2.72 0-4.924 2.203-4.924 4.917 0 0.39 0.045 0.765 0.127 1.124-4.09-0.205-7.719-2.165-10.148-5.144-0.423 0.722-0.666 1.561-0.666 2.475 0 1.709 0.87 3.216 2.188 4.099-0.807-0.026-1.566-0.248-2.228-0.616v0.061c0 2.385 1.693 4.374 3.946 4.827-0.413 0.112-0.849 0.171-1.296 0.171-0.317 0-0.626-0.031-0.927-0.088 0.631 1.956 2.445 3.379 4.6 3.419-1.685 1.319-3.809 2.106-6.115 2.106-0.398 0-0.79-0.023-1.175-0.068 2.179 1.397 4.768 2.212 7.557 2.212 9.054 0 14.002-7.496 14.002-13.986 0-0.213-0.004-0.425-0.014-0.636 0.961-0.695 1.797-1.562 2.457-2.549z"></path>
                            </svg>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 24 24" fill="currentColor">
                              <title>linkedin</title>
                              <path d="M20.447 20.452h-3.554v-5.569c0-1.327-0.027-3.036-1.85-3.036-1.854 0-2.136 1.445-2.136 2.938v5.667h-3.554v-11.49h-0.014v-0.004h3.554v1.561h0.049c0.495-0.935 1.701-1.923 3.504-1.923 3.747 0 4.437 2.466 4.437 5.671v6.185zM4.797 8.339c-1.144 0-2.072-0.928-2.072-2.073s0.928-2.073 2.072-2.073c1.144 0 2.073 0.928 2.073 2.073s-0.929 2.073-2.073 2.073zM6.574 20.452h-3.554v-11.49h3.554v11.49zM22.224 0h-20.448c-0.981 0-1.776 0.795-1.776 1.776v20.448c0 0.981 0.795 1.776 1.776 1.776h20.448c0.981 0 1.776-0.795 1.776-1.776v-20.448c0-0.981-0.795-1.776-1.776-1.776z"></path>
                            </svg>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 28 28" fill="currentColor">
                              <title>github</title>
                              <path d="M13.964 0.339c-7.711 0-13.964 6.253-13.964 13.964 0 6.175 3.998 11.413 9.535 13.262 0.698 0.127 0.953-0.303 0.953-0.672 0-0.331-0.012-1.209-0.018-2.373-3.878 0.843-4.697-1.869-4.697-1.869-0.635-1.615-1.553-2.047-1.553-2.047-1.271-0.869 0.095-0.851 0.095-0.851 1.403 0.099 2.142 1.441 2.142 1.441 1.248 2.138 3.275 1.52 4.073 1.162 0.127-0.905 0.488-1.52 0.888-1.87-3.096-0.352-6.352-1.548-6.352-6.89 0-1.522 0.544-2.767 1.438-3.744-0.143-0.353-0.625-1.771 0.136-3.691 0 0 1.176-0.376 3.854 1.43 1.118-0.311 2.318-0.467 3.51-0.473 1.191 0.006 2.391 0.162 3.51 0.473 2.677-1.806 3.852-1.43 3.852-1.43 0.762 1.92 0.28 3.338 0.137 3.691 0.894 0.977 1.436 2.222 1.436 3.744 0 5.355-3.262 6.535-6.367 6.878 0.502 0.433 0.951 1.288 0.951 2.595 0 1.874-0.017 3.383-0.017 3.845 0 0.373 0.251 0.806 0.963 0.669 5.536-1.853 9.53-7.088 9.53-13.26 0-7.711-6.254-13.964-13.965-13.964zM5.268 20.076c-0.031 0.07-0.142 0.091-0.243 0.043-0.107-0.045-0.166-0.141-0.133-0.211 0.029-0.068 0.141-0.092 0.249-0.042 0.105 0.047 0.164 0.141 0.127 0.21zM5.771 20.536c-0.067 0.062-0.198 0.033-0.288-0.068-0.097-0.099-0.118-0.229-0.049-0.291 0.067-0.063 0.197-0.033 0.294 0.066 0.096 0.101 0.126 0.231 0.043 0.293zM6.205 21.234c-0.092 0.065-0.244 0.004-0.339-0.128-0.092-0.134-0.092-0.293 0.004-0.357 0.092-0.065 0.241-0.006 0.339 0.126 0.092 0.135 0.092 0.294-0.004 0.359zM6.897 22.024c-0.082 0.092-0.258 0.068-0.389-0.059-0.135-0.126-0.172-0.298-0.086-0.388 0.086-0.091 0.258-0.066 0.391 0.059 0.134 0.126 0.179 0.296 0.084 0.388zM7.853 22.477c-0.037 0.12-0.225 0.175-0.414 0.126-0.189-0.047-0.316-0.177-0.279-0.297 0.035-0.121 0.225-0.178 0.414-0.126 0.189 0.045 0.316 0.175 0.279 0.297zM9.012 22.599c0.004 0.125-0.141 0.23-0.322 0.234-0.18 0.004-0.322-0.095-0.322-0.218 0-0.126 0.141-0.23 0.322-0.234 0.18-0.004 0.322 0.094 0.322 0.218zM10.107 22.477c0.033 0.12-0.095 0.252-0.281 0.283-0.17 0.031-0.34-0.045-0.378-0.162-0.033-0.122 0.099-0.252 0.27-0.283 0.186-0.031 0.346 0.042 0.389 0.162z"></path>
                            </svg>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SignUp;
